import { render, staticRenderFns } from "./DetalleMovimientos.vue?vue&type=template&id=66dc09ab&scoped=true&lang=pug&"
import script from "./DetalleMovimientos.vue?vue&type=script&lang=js&"
export * from "./DetalleMovimientos.vue?vue&type=script&lang=js&"
import style0 from "./DetalleMovimientos.vue?vue&type=style&index=0&id=66dc09ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc09ab",
  null
  
)

export default component.exports